import { render, staticRenderFns } from "./profile-history.vue?vue&type=template&id=c166c274&"
import script from "./profile-history.vue?vue&type=script&lang=js&"
export * from "./profile-history.vue?vue&type=script&lang=js&"
import style0 from "./profile-history.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports